<template>
  <div id="print-step">
    <print ref="print">
      <page class="receipts">
        <template v-for="index in 2">
          <div :key="index">
            <div class="nation">{{ $t('NATION') }}</div>
            <div class="motto">{{ $t('MOTTO') }}</div>
            <br/>
            <div class="hr"/>
            <div class="header">
              <div class="logo-holder">
                <logo-inversed-circle class="icon"/>
                <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
              </div>
              <div class="title-info">
                <span class="bill">{{ $t('AMOUNT_BILL') }}</span><br/>
                <strong class="info">{{ $t('CONTRACT_ID') }} ({{ $t('CNTRCT') }}): {{ info.branch.branchName }}-{{ contractMifosId }}</strong><br/>
                <strong class="info">{{ $t('CLIENT_ID') }} (KH): HCMKH-{{ info.client.mifosId }}</strong><br/>
                <strong class="info">{{ $t('STORAGE') }}: {{ info.storage.branchName }}</strong><br/>
              </div>
            </div>
            <table class="bill">
              <tr>
                <td><strong>{{ $t('REDEEM_DATE') }}:</strong></td>
                <td><strong class="margin-left">{{ moment(info.transactionDate, DISPLAY_DATE_FORMAT).format('DD-M-YYYY') }}</strong></td>
              </tr>
              <tr>
                <td>{{ $t('BILL_CREATED_DATE') }}:</td>
                <td><span class="margin-left">{{ today }}</span></td>
              </tr>
              <tr>
                <td><strong>{{ $t('FULL_NAME') }} (KH):</strong></td>
                <td><strong class="margin-left">{{ info.client.name }}</strong></td>
              </tr>
              <tr>
                <td>{{ $t('PHONE_NUMBER') }}:</td>
                <td><span class="margin-left">{{ info.client.primaryPhone }}</span></td>
              </tr>
              <tr>
                <td>{{ $t('ADDRESS') }}:</td>
                <td><span class="margin-left">{{ info.client.fullAddress }}</span></td>
              </tr>
              <tr>
                <td><strong>{{ $t('REASON') }}:</strong></td>
                <td><strong class="margin-left">{{ $t('REDEEM_CNTRCT_NUMBER') }} {{ contractMifosId }}</strong></td>
              </tr>
              <template v-if="discount">
                <tr>
                  <td><strong>{{ $t('TOTAL_AMOUNT') }}:</strong></td>
                  <td><strong class="margin-left">{{ addCommas(Math.round(totalAmount * 1000000 + info.promotionAmount * 1000000)) }} VNĐ</strong></td>
                </tr>
                <tr>
                  <td><strong>{{ $t('DISCOUNT') }}:</strong></td>
                  <td><strong class="margin-left">({{ addCommas(Math.round(info.promotionAmount * 1000000)) }}) VNĐ</strong></td>
                </tr>
                <tr>
                  <td><strong>{{ $t('PROCEEDS') }}:</strong></td>
                  <td><strong class="margin-left">{{ addCommas(Math.round(totalAmount * 1000000)) }} VNĐ</strong></td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td><strong>{{ $t('TOTAL_AMOUNT') }}:</strong></td>
                  <td><strong class="margin-left">{{ addCommas(Math.round(totalAmount * 1000000)) }} VNĐ</strong></td>
                </tr>
              </template>
            </table>
            <b-row class="sign">
              <b-col cols="6">
                <center>
                  <strong>{{ $t('PAYER') }}</strong><br>
                  <strong>({{ $t('SIGN_AND_WRITE_FULL_NAME') }})</strong>
                </center>
              </b-col>
              <b-col cols="6">
                <center>
                  <strong>{{ $t('VOTER') }}</strong><br>
                  <strong>({{ $t('SIGN_AND_WRITE_FULL_NAME') }})</strong>
                </center>
              </b-col>
            </b-row>
          </div>
          <div :key="`${index}-divider`" v-if="index==1" class="divider"/>
        </template>
      </page>
    </print>

    <div id="note" class="border">
      <center>{{ $t('PLEASE_CHECK_MONEY') }} {{ $t('AND') }} {{ $t('PRINT_BILL') }}</center>
      <div class="buttons d-flex justify-content-center">
        <primary-button :disabled="closed" @click="back" class="button primary-button" white rounded-corner :text="$t('BACK')" />
        <icon-button @click="print" class="button" independence :icon="faPrint" :size="40"/>
        <primary-button :disabled="!closed" @click="next" class="button primary-button" rounded-corner :text="$t('END')" />
      </div>
    </div>
  </div>
</template>

<script>
import LogoInversedCircle from '@/components/LogoInversedCircle';
import PrimaryButton from '@/components/PrimaryButton';
import IconButton from '@/components/IconButton';
import Print from '@/components/Print';
import Page from '@/components/Page';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { addCommas } from '@/helpers';

import loans from '@/services/loans';

import { DATE_FORMAT, DISPLAY_DATE_FORMAT, CONTRACT_STATUSES as STATUSES } from '@/consts';

import moment from 'moment';
import { computed, ref } from '@vue/composition-api';

const { useState, useGetters } = createNamespacedHelpers('contractRedeem');

export default {
  name: 'PrintStep',
  components: {
    LogoInversedCircle,
    PrimaryButton,
    IconButton,
    Print,
    Page,
  },
  setup(props, { emit, root, refs }) {
    const { id: contractMifosId } = root.$route.params;

    const { info } = useState(['info']);

    const { totalAmount } = useGetters(['totalAmount']);

    const today = moment().format('DD-M-YYYY HH:mm:ss');

    const closed = ref(false);

    const discount = computed(() => !info.value.prepaid && info.value.promotionAmount);

    const back = () => { emit('back'); };

    const next = () => { emit('next'); };

    const print = async () => {
      if (!closed.value) {
        const data = {
          submissionDate: moment(info.value.transactionDate, DISPLAY_DATE_FORMAT).format(DATE_FORMAT),
        };
        await loans.setContractStatus(info.value.id, STATUSES.CLOSED, data);
        closed.value = true;
      }
      refs.print.print();
    };

    return {
      contractMifosId,
      info,
      today,
      discount,
      totalAmount,
      closed,
      addCommas,
      back,
      next,
      moment,
      print,
      faPrint,
      DISPLAY_DATE_FORMAT,
    };
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#print-step {

  .receipts {
    font-size: 14px;
    padding: 5mm 10mm 5mm 10mm;
  }

  .hr {
    border: 1px solid $iron;
    width: 320px;
    margin: 0px auto;
  }

  .nation {
    size: 13px;
    text-align: center;
  }

  .motto {
    size: 11px;
    line-height: 18px;
    text-align: center;
  }

  .header {
    margin-top: 30px;
    position: relative;

    .logo-holder {
      position: absolute;
      top: 5px;
      left: 0;

      .left {
        padding-left: 26px;
        padding-top: 7px;
      }

      .icon {
        color: $alizarinCrimson;
        height: 80px;
        width: 80px;
      }

      .camdo {
        font-size: 15px;
        color: $carmine;
        font-family: 'Source Sans Pro', Tahoma, Arial;
      }

      .nhanh {
        font-size: 15px;
        color: $alizarinCrimson;
      }
    }

    .title-info {
      text-align: center;
      width: 100%;
    }

    .bill {
      text-transform: uppercase;
      font-weight: bolder;
      font-size: 24px;
    }

    .info {
      font-size: 13px;
    }
  }

  ul {
    list-style-type: circle;
  }

  table {
    width: 100%;
    border-spacing: 0;

    &.bill {
      margin-top: 50px;
      tr {
        td {
          &:first-child {
            width: 115px;
          }
        }
      }
    }


    tr {
      td {
        &:first-child {
          width: 115px;
        }
      }
    }

    .margin-left {
      margin-left: 50px;
    }

    td {
      &.label {
        width: 120px;
        vertical-align: top;
      }
    }
  }

  .sign {
    margin-top: 20px;
  }

  .divider {
    border: 1px solid $black;
    width: 100%;
    margin-top: 150px;
    margin-bottom: 30px;
  }

  #note {
    background-color: $white;
    font-size: 20px;
    padding: 30px;
    position: fixed;
    top: 200px;
    right: 15px;
    width: 350px;
    border-radius: 4px;

    @media (max-width: 1600px) {
      opacity: 0.5;
      transition: all .2s ease-in-out;

      &:hover {
        opacity: 1;
      }
    }

    center {
      font-weight: bolder;
      text-transform: uppercase;
    }

    .buttons {
      margin-top: 28px;

      .button {
        margin: 0px 4px;
        box-shadow: 0px 3px 6px $silver;
      }

      .primary-button {
        padding: 0px 20px;

        /deep/ span {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
